import {
  Box,
  Button,
  Divider,
  Flex,
  useMediaQuery,
} from '@podiumhq/design-system';

import { TRIAL_CHECKOUT_ROUTE } from 'components/Checkout/constants';
import { BUY_NOW_CARDS } from 'components/PricingPackaging/constants';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { FakeWrapper } from '../../layout';
import { Subheading } from '../../styles';
import { redirectToOnboarding } from '../../utils';

import BuyNowCard from './BuyNowCard';

const BuyNowWithDiscount = () => {
  const { changeCheckoutPage } = useSelectPlanCheckoutContext();
  const [isSmallerThan1180px] = useMediaQuery(`(max-width: 1180px)`);

  const handleViewPlans = () => changeCheckoutPage(TRIAL_CHECKOUT_ROUTE);

  return (
    <FakeWrapper
      marginTop={-55}
      showIcon={true}
      title="Skip the trial, save money."
      modalWidth="640px"
      padding={isSmallerThan1180px ? '0px' : null}
    >
      <Subheading>
        {isSmallerThan1180px
          ? 'Already know what you want? Pick a plan today, and you’ll get 10% off.'
          : 'Want access to all that Podium has to offer? Pick a plan today, and get 10% off every month for as long as you continue to use Podium.'}
      </Subheading>

      <Flex
        align={isSmallerThan1180px ? 'center' : 'flex-end'}
        direction={isSmallerThan1180px ? 'column' : 'row'}
        mb="21.5px"
        mt="-18px"
        gap="8px"
      >
        {BUY_NOW_CARDS.map((card) => (
          <BuyNowCard key={card.cardId} {...card} />
        ))}
      </Flex>

      {!isSmallerThan1180px && (
        <>
          <Flex justifyContent="center">
            <Button
              color="blue.base"
              onClick={handleViewPlans}
              size="sm"
              variant="ghost"
            >
              View all plan details
            </Button>
          </Flex>

          <Divider mt="19px" mb="24px" />
        </>
      )}

      <Box justifyContent="right">
        <Button
          color="white"
          float={isSmallerThan1180px ? '' : 'right'}
          onClick={redirectToOnboarding}
          size="md"
          variant="primary"
          width={isSmallerThan1180px ? '100%' : ''}
        >
          Continue with free trial
        </Button>
      </Box>

      {isSmallerThan1180px && (
        <Flex justifyContent="center">
          <Button
            color="blue.base"
            mt="15.5px"
            onClick={handleViewPlans}
            size="sm"
            variant="ghost"
          >
            View all plan details
          </Button>
        </Flex>
      )}
    </FakeWrapper>
  );
};

export default BuyNowWithDiscount;
